/**
 * 放水记录路由
 */
const LianReleaseRouter = {
  path: 'lianRelease',
  name: 'LianRelease',
  meta: {
    requiresAuth: false,
    leftMenu: true          // false表示不需要左边菜单栏
  },
  component: () => import('@/views/LianRelease/index')
}
export default LianReleaseRouter
